module.exports = __webpack_public_path__ + "img/back-arrow.30a75409.svg";